import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useToaster, toast } from 'react-hot-toast';
import {
  NotificationContainer,
  ToastWrapper,
  IconWrapper,
  ContentWrapper,
  MessageText,
  CancelIconWrapper,
} from './Notifications.Style';
import { getToastStyle } from '@/config/toastConfig';

const TOAST_DURATION = 1000000; // Duration in milliseconds

const Notifications = ({ fadeDuration = 300 }) => {
  const { toasts } = useToaster();
  const [activeToast, setActiveToast] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const timeoutRef = useRef(null);

  const hideToast = useCallback(() => {
    setIsVisible(false);
    timeoutRef.current = setTimeout(() => {
      if (activeToast) {
        toast.dismiss(activeToast.id);
      }
      setActiveToast(null);
    }, fadeDuration);
  }, [activeToast, fadeDuration]);

  const handleCloseClick = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    hideToast();
  }, [hideToast]);

  useEffect(() => {
    if (toasts.length > 0) {
      const latestToast = toasts[toasts.length - 1];
      if (!activeToast || latestToast.id !== activeToast.id) {
        setActiveToast(latestToast);
        setIsVisible(true);

        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(hideToast, TOAST_DURATION);
      }
    } else if (activeToast && toasts.length === 0) {
      hideToast();
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [toasts, hideToast, activeToast]);

  if (!activeToast) return null;

  const toastStyle = getToastStyle(activeToast.type);

  return (
    <NotificationContainer>
      <ToastWrapper
        key={activeToast.id}
        type={activeToast.type}
        background={toastStyle.background}
        isVisible={isVisible}
        fadeDuration={fadeDuration}
      >
        <IconWrapper type={activeToast.type} dangerouslySetInnerHTML={{ __html: toastStyle.icon }} />
        
        <ContentWrapper>
          <MessageText>{activeToast.message}</MessageText>
        </ContentWrapper>

        <CancelIconWrapper 
          onClick={handleCloseClick}
          dangerouslySetInnerHTML={{ __html: toastStyle.cancleIcon }}
        />
      </ToastWrapper>
    </NotificationContainer>
  );
};

export default Notifications;